const initialState = [
  {
    seriesList: [],
    seriesInfo: [],
    seriesCategory: [],
    isLoading: false,
    isSeriesInfoLoading: false,
  },
];

const seriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_REDUCER_STATE":
      return {
        ...initialState,
      };
    case "GET_SERIES_LIST":
      return {
        ...state,
        seriesList: action.payload,
      };

    case "GET_SERIES_INFO":
      return {
        ...state,
        seriesInfo: action.payload,
      };
    case "GET_SERIES_CATEGORY":
      return {
        ...state,
        seriesCategory: action.payload,
      };
    case "LOADING_START":
      return {
        ...state,
        isLoading: true,
      };
    case "LOADING_END":
      return {
        ...state,
        isLoading: false,
      };
    case "SERIES_INFO_LOADING_START":
      return {
        ...state,
        isSeriesInfoLoading: true,
      };
    case "SERIES_INFO_LOADING_END":
      return {
        ...state,
        isSeriesInfoLoading: false,
      };
    default:
      return state;
  }
};

export default seriesReducer;
